import { Paper, PaperProps } from '@mui/material'
import React from 'react'

type  WcPaperProps = PaperProps ;

export const WcPaper = ({...props}:WcPaperProps) => (
    <Paper {...props}></Paper>
  )